import { IRegistryReportsTest } from "../../types";
import { ACTIONS, RegisterTestActions } from "./testRegistryActions";

export const registerTestReducer = (state: IRegistryReportsTest, action: RegisterTestActions): IRegistryReportsTest => {
  const { type, payload } = action;

  switch (type) {
    case ACTIONS.EDIT_TEST:
      return {
        ...state,
        editTest: payload.editTest
      };
    case ACTIONS.TEST:
      return {
        ...state,
        test: payload.test
      };

    case ACTIONS.MIN_CORRECT_ANSWERS_COUNT:
      return {
        ...state,
        minCorrectAnswersCount: payload.minCorrectCunt
      };
    case ACTIONS.OPEN_FORM:
      return {
        ...state,
        openForm: payload.openForm
      };
    case ACTIONS.ADD_QUESTION:
      return {
        ...state,
        addQuestion: payload.addQuestion
      };
  }
};
